module.exports = __webpack_public_path__ + "img/logo2.2f1e3bea.png";